exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-7e9655f9]{display:table;border-collapse:separate}tr[data-v-7e9655f9]{display:table-row!important}tr[style*=transform][data-v-7e9655f9]{border-collapse:separate!important}td[data-v-7e9655f9]{padding:5px;border:1px solid #ccc!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e9655f9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/table.vue
// module id = 82
// module chunks = 0